"use strict";

import { getDataDogRUM } from '@autoguru/logs/datadog';
export let PerformanceMonitor = /*#__PURE__*/function () {
  function PerformanceMonitor(enabled = true) {
    this.enabled = enabled;
  }

  /**
   * Log a performance metric
   */
  var _proto = PerformanceMonitor.prototype;
  _proto.logMetric = function logMetric(metric, duration) {
    if (!this.enabled) return;

    // Performance API marking
    if (typeof performance !== 'undefined') {
      performance.mark(`i18n_${metric}_end`);
      try {
        performance.measure(`i18n_${metric}`, undefined, `i18n_${metric}_end`);
      } catch (_e) {
        // Ignore if start mark doesn't exist
      }
    }

    // Log slow operations in development
    if (__DEBUG__) {
      if (duration > 500) {
        console.warn(`[i18n] Slow operation: ${metric} took ${duration}ms`);
      }
    }

    // DataDog RUM integration - use window.datadogRum (set by app-shell)
    if (typeof window !== 'undefined') {
      const datadogRum = getDataDogRUM();
      if (datadogRum !== null && datadogRum !== void 0 && datadogRum.addAction) {
        try {
          datadogRum.addAction('i18n_performance', {
            metric,
            duration
          });
        } catch (_e) {
          // Silent failure for monitoring
        }
      }
    }
  }

  /**
   * Start timing an operation
   */;
  _proto.startTimer = function startTimer() {
    return performance.now();
  }

  /**
   * End timing and log the metric
   */;
  _proto.endTimer = function endTimer(startTime, metricName) {
    const duration = performance.now() - startTime;
    this.logMetric(metricName, duration);
    return duration;
  }

  /**
   * Log a manifest load event
   */;
  _proto.logManifestLoad = function logManifestLoad(locale, duration, success) {
    this.logMetric(`manifestLoad_${locale}`, duration);

    // Additional context for manifest loads
    if (typeof window !== 'undefined' && window.analytics) {
      try {
        window.analytics.track('Manifest Loaded', {
          locale,
          duration,
          success,
          timestamp: Date.now()
        });
      } catch (_e) {
        // Silent failure
      }
    }
  }

  /**
   * Log a translation load event
   */;
  _proto.logTranslationLoad = function logTranslationLoad(language, namespace, duration, fromCache) {
    const metricName = `translationLoad_${language}_${namespace}_${fromCache ? 'cached' : 'network'}`;
    this.logMetric(metricName, duration);

    // Additional context for translation loads
    if (typeof window !== 'undefined' && window.analytics) {
      try {
        window.analytics.track('Translation Loaded', {
          language,
          namespace,
          duration,
          fromCache,
          timestamp: Date.now()
        });
      } catch (_e) {
        // Silent failure
      }
    }
  };
  return PerformanceMonitor;
}();